import React from 'react';
import MediaQuery from 'react-responsive';
import { variables } from '../../components/utils';

export const breakpointM = Number(variables.medium);
export const breakpointL = Number(variables.large);

const Viewport: React.FC<{
  small: React.ReactNode;
  medium?: React.ReactNode;
  large?: React.ReactNode;
  notSmall?: React.ReactNode;
}> = ({ small, medium, large, notSmall }) => (
  <>
    {/* Small Only */}
    {small && <MediaQuery maxWidth={breakpointM}>{small}</MediaQuery>}

    {/* Small and Large */}
    {small && !medium && large && (
      <MediaQuery minWidth={breakpointM} maxWidth={breakpointL}>
        {small}
      </MediaQuery>
    )}

    {/* Not Small */}
    {notSmall && <MediaQuery minWidth={breakpointM}>{notSmall}</MediaQuery>}

    {/* Medium Only */}
    {medium && (
      <MediaQuery minWidth={breakpointM} maxWidth={breakpointL}>
        {medium}
      </MediaQuery>
    )}

    {/* Large Only */}
    {large && <MediaQuery minWidth={breakpointL}>{large}</MediaQuery>}
  </>
);

export default Viewport;
